import { GuidHelper } from "@/Common/Helpers/GuidHelper";

class RiskFactorInfo {
    public Id?: string;
    public Name: string;
    public RiskFactorCodeId?: string;
    public Details?: string;

    constructor() {
        this.Id = GuidHelper.NewGuid();
    }
}

export { RiskFactorInfo };
